// component/policies/PolicyPageLayout.js
import React, { useEffect } from "react";
import { CssBaseline } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Navbar from "../../redesign/components/Navbar";
import Footer from "../../redesign/components/Footer";
import config from "../../config";
import { homePagePath } from "../../constant";
import {
  formatRegionAddress,
  getCurrentRegion,
  getRegionContactInfo,
} from "../../util/contactRegion";
import "./PolicyPages.css";

const PolicyFooter = () => {
  const region = getRegionContactInfo();
  const currentRegion = getCurrentRegion();
  const regionLabel = currentRegion === "usa" ? "USA" : "India";

  return (
    <div className="policy-footer">
      <div className="policy-footer-divider" />
      <h3 style={{ marginTop: 16, marginBottom: 8 }}>Contact our CEO:</h3>
      <p>
        <strong>{region.name}</strong>
      </p>
      <p>
        <a href={`mailto:${region.email}`}>{region.email}</a>
      </p>
      {region.phone && (
        <p>
          Phone: <a href={`tel:${region.phone}`}>{region.phone}</a>
        </p>
      )}
      <div style={{ marginTop: 16 }}>
        <p><strong>Company:</strong> {config.companyFullName}</p>
        <p>
          <strong>Address:</strong> {formatRegionAddress(region.address)}
        </p>
        <p><strong>Region:</strong> {regionLabel}</p>
      </div>
      <p className="policy-version">Last Updated: June 2025 | Version 1.0</p>
    </div>
  );
};


const PolicyPageLayout = ({ title, children }) => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);


  const backToHome = () => {
    isLoggedIn ? navigate("/dashboard") : navigate(homePagePath);
  };


  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);


  return (
    <div style={{ width: "100%" }}>
      <CssBaseline />
      <Navbar />
      <div className={`main-container ${!isLoggedIn && "no-auth"}`}>
        <div className="event-service-head-inner-policy">
          <div>
            <button
              className="back-to-services-btn"
              onClick={backToHome}
            >
              <i className='pi pi-arrow-left'></i> Home
            </button>

          </div>
        </div>
        <div className="center-heading">
          <h1>{title}</h1>
        </div>
        <div className="frontend-container">
          <div className="event-form-inner">
            <div className="event-form-body alter full">
              <div className="event-form-content policy-content">
                {children}
                <PolicyFooter />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};


export { PolicyPageLayout, PolicyFooter };
export default PolicyPageLayout;



